/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendPatchedProjectConfigRequestDto } from '../../models/backend-patched-project-config-request-dto';
import { BackendProjectConfigDto } from '../../models/backend-project-config-dto';

export interface ProjectsProjectConfigPartialUpdate$FormData$Params {
  id: number;
  body?: BackendPatchedProjectConfigRequestDto;
}

export function projectsProjectConfigPartialUpdate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: ProjectsProjectConfigPartialUpdate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendProjectConfigDto>> {
  const rb = new RequestBuilder(rootUrl, projectsProjectConfigPartialUpdate$FormData.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendProjectConfigDto>;
    }),
  );
}

projectsProjectConfigPartialUpdate$FormData.PATH = '/api/projects/project-config/{id}/';
